import { Atom } from ":mods";

export function createTalkInfoInputs() {
  const PresentCaseInPerson = Atom.Form.createInput("", {
    required: true,
  });
  const ProjectDescription = Atom.Form.createTextArea("", {
    required: false,
  });
  const ProjectDescriptionMoreDetails = Atom.Form.createTextArea("", {
    required: false,
  });

  const Actions = Atom.Form.createFormActions({
    PresentCaseInPerson,
    ProjectDescription,
    ProjectDescriptionMoreDetails,
  });
  return {
    Actions,
    PresentCaseInPerson,
    ProjectDescription,
    ProjectDescriptionMoreDetails,
  };
}
